<script>
    import gsap from 'gsap';
    import DrawSVGPlugin from 'gsap/DrawSVGPlugin';
    import {onMount, onDestroy} from "svelte";

    gsap.registerPlugin(DrawSVGPlugin);

    let tl = gsap.timeline();

    let container;

    onMount(() => {

        const elements = Array.from(container.getElementsByTagName('path'));

        tl.fromTo(elements, {
            drawSVG: "100% 100%",
            transformOrigin: 'center center',
        }, {drawSVG: "0% 100%",
            stagger: 0.15,
            duration: 1,
        }, 0.5);

        tl.play();
    });

    onDestroy(() => {
        tl.clear();
        tl = null;
    })
</script>

<div class="leadership-container" bind:this={container}>
    <div class="leadership-column-right">
        <h1 class="leadership-header">How thought leadership gets you noticed</h1>
        <div class="leadership-introduction">
            <p>Good thought leadership positions you as an authority on the issues your customers are wrestling with as
                they try to transform their businesses. When looking for insight they can trust, executives in our
                survey prioritised three things:</p>
        </div>
    </div>
    <div class="leadership-info-box">
        <div class="leadership-info-diagram">
            <svg width="279" height="144" viewBox="0 0 279 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M23.972 79.316C13.431 79.8 5.09499 72.573 2.31299 64.416C-0.966008 54.799 1.98199 44.369 10.185 38.636C12.962 36.695 16.442 35.646 19.733 34.606C21.133 34.165 21.633 33.736 21.863 32.357C23.718 21.037 29.277 12.057 39.155 6.06298C45.9404 1.95712 53.9202 0.280163 61.7844 1.30739C69.6485 2.33461 76.9298 6.00497 82.433 11.716C83.263 12.569 84.068 13.446 84.995 14.429C92.632 11.088 100.045 10.735 106.936 15.434C114.651 20.695 117.384 28.461 116.564 37.513C116.374 39.602 116.788 40.45 118.755 41.213C129.487 45.372 134.645 56.624 131.405 68.449"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M147.421 93.322C144.181 81.497 149.339 70.245 160.071 66.086C162.038 65.324 162.452 64.476 162.262 62.386C161.442 53.334 164.175 45.568 171.89 40.307C178.781 35.607 186.19 35.961 193.83 39.307C194.758 38.323 195.563 37.446 196.392 36.594C201.895 30.8827 209.177 27.2122 217.041 26.185C224.905 25.1578 232.885 26.8349 239.671 30.941C249.549 36.932 255.108 45.914 256.963 57.235C257.189 58.613 257.695 59.042 259.093 59.483C262.384 60.523 265.864 61.572 268.641 63.513C276.841 69.247 279.792 79.676 276.513 89.294C273.731 97.455 265.395 104.732 254.854 104.194"
                      stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M95.021 62.4C101.321 59.642 107.445 59.35 113.134 63.23C119.503 67.572 121.759 73.984 121.082 81.457C120.925 83.182 121.267 83.882 122.891 84.511C131.751 87.944 136.009 97.234 133.334 106.996C131.249 114.608 125.486 119.246 117.573 119.746C113.694 120.041 109.796 119.537 106.12 118.264C105.797 118.171 105.456 118.158 105.126 118.224C104.797 118.291 104.488 118.435 104.226 118.646C99.774 125.187 93.269 128.458 85.838 130.084C75.655 132.313 65.776 131.418 56.49 126.384C52.4424 124.303 49.1275 121.035 46.99 117.017C46.7025 116.677 46.3416 116.406 45.9344 116.224C45.5273 116.043 45.0844 115.957 44.639 115.971C40.7328 116.109 36.8857 114.988 33.6657 112.772C30.4457 110.556 28.0236 107.364 26.757 103.666C24.05 95.726 26.485 87.116 33.257 82.382C35.705 80.8878 38.3618 79.7665 41.14 79.055C42.295 78.691 42.713 78.337 42.899 77.199C44.43 67.853 49.02 60.438 57.174 55.491C62.7758 52.1025 69.3632 50.7189 75.8549 51.5673C82.3466 52.4157 88.3571 55.4457 92.9 60.16C93.59 60.864 94.254 61.588 95.021 62.4Z"
                      stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M198.742 132.321V129.857C198.661 122.859 195.809 116.179 190.811 111.28C187.113 107.536 184.543 102.828 183.393 97.6935C182.244 92.5587 182.562 87.2041 184.31 82.2413C186.059 77.2784 189.168 72.9074 193.283 69.6274C197.397 66.3474 202.351 64.2906 207.579 63.692C208.666 63.5772 209.759 63.5191 210.852 63.518C217.757 63.4959 224.421 66.0492 229.544 70.679C232.33 73.17 234.59 76.1927 236.192 79.5693C237.794 82.946 238.705 86.6087 238.872 90.3424C239.039 94.076 238.458 97.8053 237.163 101.311C235.869 104.817 233.887 108.029 231.334 110.759C226.019 116.259 222.998 123.576 222.883 131.223V132.823C222.881 133.823 222.483 134.782 221.776 135.489C221.069 136.196 220.11 136.594 219.11 136.596H202.535C200.335 136.615 198.743 134.805 198.743 132.322L198.742 132.321Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M209.757 69.279C206.205 69.678 202.786 70.8632 199.749 72.7486C196.712 74.6341 194.133 77.1723 192.2 80.179"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M201.2 136.6V139.345C201.2 140.307 201.582 141.23 202.263 141.911C202.943 142.592 203.866 142.974 204.829 142.974H217.3C218.263 142.974 219.186 142.592 219.866 141.911C220.547 141.231 220.93 140.308 220.93 139.345V136.245"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M252.851 90.289H242.68" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M246.815 68.803L238.007 73.888" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M230.844 53.214L225.759 62.022" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M209.219 47.699V57.87" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M187.733 53.735L192.818 62.543" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M172.143 69.705L180.951 74.79" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M166.628 91.331H176.799" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M172.664 112.817L181.472 107.732" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M215.113 102.676C218.629 102.676 221.479 99.8258 221.479 96.31C221.479 92.7941 218.629 89.944 215.113 89.944C211.597 89.944 208.747 92.7941 208.747 96.31C208.747 99.8258 211.597 102.676 215.113 102.676Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M214.374 87.938C215.136 86.4775 216.272 85.2459 217.666 84.3694C219.061 83.4928 220.663 83.0029 222.309 82.9498C223.956 82.8967 225.586 83.2824 227.034 84.0673C228.482 84.8521 229.695 86.008 230.55 87.4163C231.404 88.8247 231.868 90.4348 231.894 92.0816C231.921 93.7285 231.509 95.3528 230.701 96.788C229.893 98.2233 228.718 99.4178 227.296 100.249C225.874 101.08 224.257 101.519 222.61 101.519"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="leadership-info-text">
            <div class="info-box-header">1</div>
            <div class="info-box-description">Original, insightful and thought-provoking</div>
        </div>
    </div>
    <div class="leadership-info-box">
        <div class="leadership-info-diagram">
            <svg width="100" height="100" viewBox="0 0 142 146" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 144.94V110.8h34.9v34.14" stroke="#fff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M35.9 144.8V89.85h34.91v54.97" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M70.9 144.6V60.63h34.9v83.97" stroke="#fff" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M105.9 144.43V34.15h34.9v110.28" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M1.18 110.81 111.28 1.07M111.1 25.27l.18-24.2M87.25 1l24.03.07" stroke="#fff" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="leadership-info-text">
            <div class="info-box-header">2</div>
            <div class="info-box-description">Supported by compelling evidence — data, research and proven experience
            </div>
        </div>
    </div>
    <div class="leadership-info-box">
        <div class="leadership-info-diagram last-diagram">
            <svg width="288" height="118" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M88.4 34.2a21.83 21.83 0 1 1-23.68.97" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M111.03 106.69v-8.84a23.1 23.1 0 0 0-19.35-22.8 23.71 23.71 0 0 1-28.82-.14 23.1 23.1 0 0 0-20.37 22.94v18.32M76.28 11.5l5.38 10.9 12.04 1.76-8.71 8.49 2.06 11.98-10.77-5.66-10.77 5.66 2.06-11.98-8.71-8.5 12.04-1.74 5.38-10.91Z"
                      stroke="#008ED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M41.06 86.6a50.14 50.14 0 1 1 70.91 0" stroke="#008ED2" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M1 116.53h113.06a32.42 32.42 0 0 0 22.92-9.49l23.7-23.7a32.4 32.4 0 0 1 22.92-9.5h31.85c8.6 0 16.84-3.41 22.92-9.49l47.87-47.87"
                      stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="leadership-info-text">
            <div class="info-box-header">3</div>
            <div class="info-box-description">Not a sales pitch — demonstrate your unique expertise and insight, and the
                sales will follow
            </div>
        </div>
    </div>
</div>

<style>
    .leadership-container {
        padding-right: 40px;
    }

    .leadership-header {
        color: #f5d2b5;
        font-weight: 400;
        font-size: 44px;
        line-height: 44px;
        margin-bottom: 85px;
    }

    .leadership-introduction {
        font-size: 28px;
        color: white;
    }

    .leadership-info-box {
        margin-top: 100px;
        display: flex;
        flex-direction: column;
    }

    .leadership-info-diagram {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .leadership-info-diagram svg {
        width: 80%;
    }

    .leadership-info-box > * {
        width: 90%;
    }

    .leadership-info-text {
        display: flex;
        flex-direction: column;
    }

    .info-box-header {
        color: #00a0dd;
        font-weight: 700;
        font-size: 50px;
        margin-bottom: 0;
        margin-top: 15px;
    }

    .info-box-description {
        font-weight: 700;
        font-size: 26px;
        margin-top: 0;
        color: white;
    }

    .last-diagram {
        transform: scale(0.8);
    }

    @media (min-width: 640px) {
        .leadership-container {
            display: flex;
            flex-direction: column;
            align-items: end;
        }

        .leadership-column-right {
            max-width: 445px;
        }

        .leadership-info-box {
            flex-direction: row;
            margin: 75px 110px 0 0;
        }

        .leadership-info-diagram svg {
            width: 50%;
            margin-right: 50px;
        }

        .leadership-info-box > * {
            width: 332px;
        }

        .leadership-info-text {
            max-width: 333px
        }

        .info-box-header {
            margin-top: 0;
        }
    }
</style>
